export default class DemographicsModel {
  constructor(data) {
    if (!data) {
      data = {};
    }
    this.state = data.state || '';
    this.total = data.total || 0;
    this.white = data.white || 0;
    this.black = data.black || 0;
    this.native = data.native || 0;
    this.asian = data.asian || 0;
    this.pacific = data.pacific || 0;
    this.multiracial = data.multiracial || 0;
    this.hispanic = data.hispanic || 0;
    this.preferredNotToAnswer = data.prefer_not_to_answer || 0;
    this.other = data.other || 0;
  }
}
